/**
 * Klaviyo embedded forms — submit handling for footer + popups.
 */
(function () {
  'use strict';

  const conf = window.gwongConfig || {};
  const formId = conf.klaviyoFormId || 'TbTSBK';

  function handleSubmit(detail) {
    if (!detail || detail.formId !== formId) return;

    const openPopup = document.querySelector('.popup-overlay.is-open');
    if (openPopup && openPopup.querySelector('[data-klaviyo-embed]')) {
      if (window.Gwong?.popups?.showDiscountCode) {
        window.Gwong.popups.showDiscountCode(openPopup);
      }
      return;
    }

    const footerEmbed = document.querySelector('.cb-footer__subscribe [data-klaviyo-embed]');
    if (footerEmbed) {
      const status = document.querySelector('[data-newsletter-status]');
      if (status) status.textContent = 'Welcome to the Glow Club. Check your inbox.';
      footerEmbed.classList.add('is-submitted');
    }
  }

  window.addEventListener('klaviyoForms', (e) => {
    if (!e.detail) return;
    if (e.detail.type === 'submit' || e.detail.type === 'redirectedToUrl') {
      handleSubmit(e.detail);
    }
  });

  window.Gwong = window.Gwong || {};
  window.Gwong.klaviyoForms = { formId, handleSubmit };
})();
